export default {
  placeholders: {
    delivery_zip_code: 'Zip code',
    delivery_city: 'City',
    delivery_street_number: 'Street number',
    delivery_street_name: 'Street name',
    type_your_address: 'Type your address',
  },
  errors: {
    address_suggestions_unavailable: "Address suggestions couldn't load. You can still enter your address below.",
  },
  buttons: {
    retry: 'Try again',
  },
};
